module.exports = __webpack_public_path__ + "img/acgk.da90c98e.png";